import ShieldAlertSvg from '@assets/images/svg/shield-alert.svg';
import React from 'react';
import { View } from 'react-native';

export interface ShieldAlertIconProps {
    size?: number;
    color?: string;
}

export function ShieldAlertIcon({ size = 19, color = '#1A1A1A' }: ShieldAlertIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ShieldAlertSvg width={size} height={size} color={color} />
        </View>
    );
}
